import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { clone } from 'lodash'
import TooltipContent from './TooltipContent'

export default class Tooltip extends Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired
  }

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this)
    this.handleClickOutside = this.handleClickOutside.bind(this)

    this.portal = document.getElementById('tooltips')
    this.tooltipRef = React.createRef()
    this.state = { visible: false, position: null }
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClick(event) {
    event.persist()

    this.setState((prevState) => {
      const newState = clone(prevState)

      if (!prevState.visible) {
        const rect = event.target.getBoundingClientRect()
        newState.position = { left: rect.x + rect.width, top: rect.y + window.scrollY - 20 }
      } else {
        newState.position = null
      }

      newState.visible = !prevState.visible

      return newState
    })
  }

  handleClickOutside(event) {
    if (this.tooltipRef && this.tooltipRef.current && !this.tooltipRef.current.contains(event.target)) {
      this.setState({ visible: false })
    }
  }

  render() {
    const { title, children } = this.props

    return (
      <div className="tooltip">
        <div className="tooltip__title"><button onClick={this.handleClick}>{title}</button></div>
        {this.state.visible
          && ReactDOM.createPortal(
            <TooltipContent position={this.state.position} tooltipRef={this.tooltipRef}>{children}</TooltipContent>,
            this.portal
          )}
      </div>
    )
  }
}
